<template>
  <v-container>
    <formWrapper :validator="v.form">
      <v-form @submit.prevent="handleSubmit">
        <v-row>
          <v-col cols="12" v-if="isEdit" class="py-0 my-0">
            <locale-select @change="onLocaleChange" />
          </v-col>
          <v-col cols="12" class="py-0 my-0">
            <form-group name="name">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  outlined
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.name"
                ></v-text-field>
              </template>
            </form-group>
          </v-col>

          <v-col cols="12" class="py-0 my-0">
            <form-group name="is_visible">
              <template slot-scope="{ attrs, listeners }">
                <v-switch
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.is_visible"
                ></v-switch>
              </template>
            </form-group>
          </v-col>

          <v-col cols="12" class="py-0 my-0">
            <v-btn
              :loading="btnLoading"
              type="submit"
              block
              large
              class="primary"
              :disabled="v.form.$invalid"
            >
              {{ $t("button.save") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </formWrapper>
  </v-container>
</template>

<script>
import { UpdateData, StoreData } from "@/helpers/apiMethods";

export default {
  name: "FormActions",

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    v: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      items: [],
      loading: true,
      btnLoading: false,
      locale: this.locale,
    };
  },
  methods: {
    onLocaleChange(locale) {
      this.locale = locale;
      this.$emit("on-locale-change", locale);
    },

    handleSubmit() {
      this.btnLoading = true;
      if (!this.isEdit) {
        // in case create
        this.handleCreate();
      } else {
        // in case edit
        this.handleUpdate();
      }
    },
    handleCreate() {
      StoreData({ reqName: "surveys", data: this.form })
        .then((res) => {
          console.log(res);
          const { survey } = res.data;
          this.$emit("on-submited", survey);
        })
        .finally(() => (this.btnLoading = false));
    },
    handleUpdate() {
      const reqData = {
        ...this.form,
        _method: "put",
        locale: this.locale,
      };
      UpdateData({
        reqName: "surveys",
        data: reqData,
        param: this.item.id,
      })
        .then((res) => {
          const { survey } = res.data;

          this.$emit("on-submited", survey);
        })
        .finally(() => (this.btnLoading = false));
    },
  },
};
</script>
